import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';

import { LinkBtn, Icon } from '../../components';
import { sendAlert } from '../../actions/utils';
import { showSelectionProcessRequest } from '../../requests/selectionProcesses';
import { showCandidatesRequest, updateCandidatesRequest } from '../../requests/candidates';
import { camelCaseEmptyStringRecursive } from '../../services/utils';

import CandidateForm from './CandidateForm';
import basicSelectionProcess from './basicSelectionProcess';
import basicCandidate from './candidate';

const CandidateEdit = () => {
  const { id: selectionProcessId, candidateId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [selectionProcess, setSelectionProcess] = useState(basicSelectionProcess);
  const [candidate, setCandidate] = useState(basicCandidate);

  useEffect(() => {
    showSelectionProcessRequest(selectionProcessId, {
      dispatch,
      successCallback: response => setSelectionProcess(camelCaseEmptyStringRecursive(response.data))
    });
  }, [selectionProcessId, dispatch]);

  useEffect(() => {
    showCandidatesRequest(candidateId, {
      dispatch,
      successCallback: response => setCandidate(camelCaseEmptyStringRecursive(response.data))
    });
  }, [candidateId, dispatch]);

  const handleSuccess = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    history.push(`/selection_processes/${selectionProcessId}`);
  };

  const handleFailure = error => {
    const { response } = error || {};
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message || 'Ocurrió un error' }));
  };

  const handleUpdate = values => {
    const { resume } = values.candidate;
    const params = snakeCaseKeys(values.candidate);

    updateCandidatesRequest(candidateId, {
      dispatch,
      params: { candidate: { ...params, resume } },
      formData: true,
      successCallback: () => handleSuccess('Candidato actualizado con éxito'),
      failureCallback: handleFailure
    });
  };

  return (
    <>
      <Row className="mb-1 my-3 align-items-center">
        <Col xs="auto">
          <LinkBtn
            variant="circle-dark"
            className="btn-circle mt-3"
            block
            to={`/selection_processes/${selectionProcessId}`}
          >
            <Icon icon="chevron-back" />
          </LinkBtn>
        </Col>

        <Col xs={10}>
          <h2 className="mt-4 ">Editar Candidato</h2>
        </Col>
      </Row>
      <div className="yellow-wrapper mt-4">
        <Col>
          <CandidateForm
            candidate={candidate}
            selectionProcess={selectionProcess}
            action="edit"
            formRequest={handleUpdate}
          />
        </Col>
      </div>
    </>
  );
};

export default CandidateEdit;
